/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindBusinessPartnersByOrganizationCertificatesQueryResponse,
  FindBusinessPartnersByOrganizationCertificatesPathParams,
  FindBusinessPartnersByOrganizationCertificatesQueryParams,
} from "../types/FindBusinessPartnersByOrganizationCertificates.ts"

export const findBusinessPartnersByOrganizationCertificatesQueryKey = (
  organizationId: FindBusinessPartnersByOrganizationCertificatesPathParams["organizationId"],
  params: FindBusinessPartnersByOrganizationCertificatesQueryParams
) =>
  [
    {
      url: "/v1/organization-v2/find-certificates-business-partners/:organizationId",
      params: { organizationId },
    },
    ...(params ? [params] : []),
  ] as const

export type FindBusinessPartnersByOrganizationCertificatesQueryKey = ReturnType<
  typeof findBusinessPartnersByOrganizationCertificatesQueryKey
>

/**
 * @summary Find certificate business partners
 * {@link /v1/organization-v2/find-certificates-business-partners/:organizationId}
 */
export async function findBusinessPartnersByOrganizationCertificates(
  organizationId: FindBusinessPartnersByOrganizationCertificatesPathParams["organizationId"],
  params: FindBusinessPartnersByOrganizationCertificatesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindBusinessPartnersByOrganizationCertificatesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/organization-v2/find-certificates-business-partners/${organizationId}`,
    params,
    ...requestConfig,
  })
  return res
}

export function findBusinessPartnersByOrganizationCertificatesQueryOptions(
  organizationId: FindBusinessPartnersByOrganizationCertificatesPathParams["organizationId"],
  params: FindBusinessPartnersByOrganizationCertificatesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findBusinessPartnersByOrganizationCertificatesQueryKey(
    organizationId,
    params
  )
  return queryOptions<
    ResponseConfig<FindBusinessPartnersByOrganizationCertificatesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindBusinessPartnersByOrganizationCertificatesQueryResponse>,
    typeof queryKey
  >({
    enabled: !!(organizationId && params),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findBusinessPartnersByOrganizationCertificates(
        organizationId,
        params,
        config
      )
    },
  })
}

/**
 * @summary Find certificate business partners
 * {@link /v1/organization-v2/find-certificates-business-partners/:organizationId}
 */
export function useFindBusinessPartnersByOrganizationCertificates<
  TData = ResponseConfig<FindBusinessPartnersByOrganizationCertificatesQueryResponse>,
  TQueryData = ResponseConfig<FindBusinessPartnersByOrganizationCertificatesQueryResponse>,
  TQueryKey extends
    QueryKey = FindBusinessPartnersByOrganizationCertificatesQueryKey,
>(
  organizationId: FindBusinessPartnersByOrganizationCertificatesPathParams["organizationId"],
  params: FindBusinessPartnersByOrganizationCertificatesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindBusinessPartnersByOrganizationCertificatesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey =
    queryOptions?.queryKey ??
    findBusinessPartnersByOrganizationCertificatesQueryKey(
      organizationId,
      params
    )

  const query = useQuery(
    {
      ...findBusinessPartnersByOrganizationCertificatesQueryOptions(
        organizationId,
        params,
        config
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
